import {
  POWER_REVIEWS_API_KEY,
  POWER_REVIEWS_MERCHANT_GROUP_ID,
  POWER_REVIEWS_MERCHANT_ID,
  POWER_REVIEWS_WRITE_REVIEW_PATH
} from '../env/public';
import config from '../config';

const powerReviews = config({
  default: {
    default: {
      /** API key. */
      apiKey: POWER_REVIEWS_API_KEY,
      /** Merchant group ID. */
      merchantGroupId: POWER_REVIEWS_MERCHANT_GROUP_ID,
      /** Merchant ID. */
      merchantId: POWER_REVIEWS_MERCHANT_ID,
      /** Path to redirect the user to write a review. */
      writeReviewPath: POWER_REVIEWS_WRITE_REVIEW_PATH
    }
  }
});

export default powerReviews;
